module.exports = __webpack_public_path__ + "static/q6answer3_hamptons_wishmas-6f8a05c30b2910125e91813df8ab7d2e.jpg";